import { createVNode as _createVNode, openBlock as _openBlock, createBlock as _createBlock } from "vue"

const _hoisted_1 = {
  viewBox: "0 0 16 15",
  fill: "none",
  xmlns: "http://www.w3.org/2000/svg"
}
const _hoisted_2 = /*#__PURE__*/_createVNode("path", {
  d: "M2.16667 2.5C2.16667 2.03976 2.53976 1.66667 3 1.66667H8C8.46024 1.66667 8.83333 1.29357 8.83333 0.833333C8.83333 0.373096 8.46024 0 8 0H3C1.61929 0 0.5 1.11929 0.5 2.5V12.5C0.5 13.8807 1.61929 15 3 15H13C14.3807 15 15.5 13.8807 15.5 12.5V7.5C15.5 7.03976 15.1269 6.66667 14.6667 6.66667C14.2064 6.66667 13.8333 7.03976 13.8333 7.5V12.5C13.8333 12.9602 13.4602 13.3333 13 13.3333H3C2.53976 13.3333 2.16667 12.9602 2.16667 12.5V2.5Z",
  fill: "currentColor"
}, null, -1)
const _hoisted_3 = /*#__PURE__*/_createVNode("path", {
  "fill-rule": "evenodd",
  "clip-rule": "evenodd",
  d: "M14.1101 1.38991C13.1518 0.431649 11.5982 0.431646 10.6399 1.38991L4.91074 7.11908C4.75446 7.27536 4.66667 7.48732 4.66667 7.70833V10C4.66667 10.4602 5.03976 10.8333 5.5 10.8333H7.79167C8.01268 10.8333 8.22464 10.7455 8.38092 10.5893L14.1101 4.86009C15.0684 3.90183 15.0684 2.34817 14.1101 1.38991ZM11.8184 2.56842C12.1258 2.26103 12.6242 2.26103 12.9316 2.56842C13.239 2.87581 13.239 3.37419 12.9316 3.68158L7.44649 9.16667H6.33333V8.05351L11.8184 2.56842Z",
  fill: "currentColor"
}, null, -1)

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  return (_openBlock(), _createBlock("svg", _hoisted_1, [
    _hoisted_2,
    _hoisted_3
  ]))
}